export class ExpedienteDiligenciaModel{
    id: string;
    folio: string;
    folioProvisional: string;
    idExpediente: string;
    idConfiguracionExpediente: string;
}
